import * as React from "react";
import KodaIcon from "./Custom Icons/KodaIcon";
import KodaPointing from "./Custom Icons/KodaPointing";
import KodaAttentive from "./Custom Icons/Koda_Attentive";
import KodaReading from "./Custom Icons/Koda Reading";
import KodaCunning from "./Custom Icons/Koda_Cunning";
import KodaHello from "./Custom Icons/Koda_Hello";

interface WalkthroughKodaProps extends React.SVGProps<SVGSVGElement> {
  expression: 0 | 1 | 2 | 3 | 4 | 5;
  size?: number;
}

/** Routes a walkthrough step expression number to the correct Koda illustration. */
export default function WalkthroughKoda({ expression, size = 52, ...rest }: WalkthroughKodaProps) {
  switch (expression) {
    case 0: return <KodaHello     width={size} {...rest} />;
    case 1: return <KodaIcon      width={size} height={size} {...rest} />;
    case 2: return <KodaPointing  width={size} height={size} {...rest} />;
    case 3: return <KodaAttentive width={size} height={Math.round(size * 317.4 / 210.2)} {...rest} />;
    case 4: return <KodaReading   width={size} height={Math.round(size * 268.4 / 210.2)} {...rest} />;
    case 5: return <KodaCunning   width={size} height={Math.round(size * 261.6 / 210.2)} {...rest} />;
  }
}
